import { useCallback, useEffect, useState } from 'react';
import { describeError } from '../../../services/errorMessage';
import { fetchVorlagen, zaehleKundenJeVorlage } from '../../../services/sifa/vorlagenService';
import type { SifaUnterweisungVorlage } from '../../../services/sifa/types';

/**
 * Laden der Vorlagen samt Zahl der Kundenkopien — der Zustand der Ansicht
 * „Unterweisungen". Muster useUnterweisungen: ein Hook, ein Ladezustand,
 * eine Fehlerzeile; Sortieren und Gruppieren macht vorlagenViewLogic.
 *
 * Fehlt Nr. 141 noch, liefert fetchVorlagen [] und die Ansicht zeigt den
 * neutralen Leerzustand — unterscheiden laesst sich das hier nicht.
 */
export const useVorlagen = () => {
  const [vorlagen, setVorlagen] = useState<SifaUnterweisungVorlage[]>([]);
  const [kopien, setKopien] = useState<Map<string, number>>(() => new Map());
  const [laden, setLaden] = useState(true);
  const [fehler, setFehler] = useState<string | null>(null);

  const neuLaden = useCallback(async () => {
    setLaden(true);
    setFehler(null);
    try {
      // Die Kopienzahl ist Anzeige und scheitert still (leere Map) — sie haelt die Liste nie auf.
      const [v, k] = await Promise.all([fetchVorlagen(), zaehleKundenJeVorlage()]);
      setVorlagen(v);
      setKopien(k);
    } catch (e) {
      setFehler(describeError(e));
    } finally {
      setLaden(false);
    }
  }, []);

  useEffect(() => { void neuLaden(); }, [neuLaden]);

  /** Antwort eines Schreibvorgangs uebernehmen — kein Neuladen nach jedem Speichern. */
  const uebernehmen = useCallback((geaendert: SifaUnterweisungVorlage) => {
    setVorlagen((prev) => [...prev.filter((v) => v.id !== geaendert.id), geaendert]);
  }, []);

  const entfernen = useCallback((id: string) => {
    setVorlagen((prev) => prev.filter((v) => v.id !== id));
  }, []);

  return { vorlagen, kopien, laden, fehler, neuLaden, uebernehmen, entfernen };
};
